export interface Location {
  country: string;
  regions: number[];
}

export function getCountriesFromLocations(locations: Location[]): string[] {
  return locations.map((l) => l.country);
}

export function getRegionsFromLocations(
  locations: Location[],
): Record<string, number[]> {
  return Object.fromEntries(locations.map((l) => [l.country, l.regions]));
}

/**
 * The inverse of {@link getRegionsFromLocations}: the API keeps countries and
 * regions apart, the pickers edit them as one list of countries with their
 * regions.
 */
export function toLocations(
  regions: Record<string, number[]> | null | undefined,
): Location[] {
  return Object.entries(regions ?? {}).map(([country, regions]) => ({
    country,
    regions,
  }));
}
